import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/report/taxReport' : '/report/taxReport'

// 添加一条报表内容
export function addR001(data) {
  return request({
    url: urlPrefix + '/addR001',
    method: 'post',
    data
  })
}

// 生成四上报表
export function addSuperviseReportList(data) {
  return request({
    url: urlPrefix + '/addSuperviseReportList',
    method: 'post',
    data
  })
}

// 上传并修改多条报表内容
export function batchUpdateR001List(data) {
  return request({
    url: urlPrefix + '/batchUpdateR001List',
    method: 'post',
    data
  })
}

// 删除一条报表内容
export function deleteR001(data) {
  return request({
    url: urlPrefix + '/deleteR001',
    method: 'post',
    data
  })
}

// 删除四上报表
export function deleteSuperviseReportList(id) {
  return request({
    url: urlPrefix + '/deleteSuperviseReportList?superviseReportListId=' + id,
    method: 'post',
  })
}

// 查询已生成的四上报表内容
export function selectR001ByPage(data) {
  return request({
    url: urlPrefix + '/selectR001ByPage',
    method: 'post',
    data
  })
}

// 查询已生成的四上报表内容导出
export function selectR001ForExport(id) {
  return request({
    url: urlPrefix + '/selectR001ForExport?reportId=' + id,
    method: 'post',
    responseType: 'arraybuffer'
  })
}

// 查询已生成的四上报表表头
export function selectR001Title(data) {
  return request({
    url: urlPrefix + '/selectR001Title',
    method: 'post',
    data
  })
}

// 生成四上报表需要的翻译项目
export function selectReportSelectOpinion(data) {
  return request({
    url: urlPrefix + '/selectReportSelectOpinion',
    method: 'post',
    data
  })
}

// 查询已生成的四上报表
export function selectSuperviseReportListByPage(data) {
  return request({
    url: urlPrefix + '/selectSuperviseReportListByPage',
    method: 'post',
    data
  })
}

// 修改一条报表内容
export function updateR001(data) {
  return request({
    url: urlPrefix + '/updateR001',
    method: 'post',
    data
  })
}

// 修改四上报表
export function updateSuperviseReportList(data) {
  return request({
    url: urlPrefix + '/updateSuperviseReportList',
    method: 'post',
    data
  })
}

// 检查报表是否可以展示
export function checkCanViewReport(cusId) {
  return request({
    url: urlPrefix + '/checkCanViewReport?cusId=' + cusId,
    method: 'post'
  })
}

// 下载导入模板
export function downloadtmpexcel(id) {
  return request({
    url: urlPrefix + '/downloadtmpexcel/batchDetail?reportId=' + id,
    method: 'get',
    responseType: 'arraybuffer'
  })
}
